export default {
  "header.logoLink":
    "一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン／Life Science Innovation Network Japan",
  "header.contact.link.title": "お問い合わせ",
  "header.youtube.link.title": "YouTubeチャンネル",
  "header.youtube.img.alt": "動画",
  "header.facebook.link.title": "Facebook",
  "header.linkedin.link.title": "LinkedIn",
  "header.x.link.title": "X",
  "header.instagram.link.title": "Instagram",
  "header.lifeScience.link.title": "ライフサイエンスビルシリーズ",
  "header.lifeScience.img.alt": "ライフサイエンスビルシリーズ",
  "header.mitsuiLinkLab.link.title": "三井リンクラボ",
  "header.mitsuiLinkLab.img.alt": "三井リンクラボ",
  "header.lbb.link.title": "LINK-BioBAY TOKYO",
  "header.lbb.img.alt": "LINK-BioBAY TOKYO",
  "header.search.placeholder": "例　ライフサイエンス",
};
